import { render, staticRenderFns } from "./WebPlayerFeedback.vue?vue&type=template&id=0bc4f4b0&scoped=true&"
import script from "./WebPlayerFeedback.vue?vue&type=script&lang=js&"
export * from "./WebPlayerFeedback.vue?vue&type=script&lang=js&"
import style0 from "./WebPlayerFeedback.vue?vue&type=style&index=0&id=0bc4f4b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc4f4b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bc4f4b0')) {
      api.createRecord('0bc4f4b0', component.options)
    } else {
      api.reload('0bc4f4b0', component.options)
    }
    module.hot.accept("./WebPlayerFeedback.vue?vue&type=template&id=0bc4f4b0&scoped=true&", function () {
      api.rerender('0bc4f4b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/WebPlayerFeedback.vue"
export default component.exports